import { Grid } from "@mui/material";
import { getTime } from "date-fns";
import { Dispatch, SetStateAction, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Supplements from "../../../common/components/functional/Supplements/Supplements";
import {
  SupplementsType,
  VariationSelection,
} from "../../../common/types/apiTypes";
import useIsLoading from "../../../hooks/useIsLoading";
import {
  SupplementsData,
  VariationSpecificSettings,
} from "../../supplements/supplementAPI";

type Props = {
  tesId: string;
  tesVariation: VariationSelection[];
  supplements: SupplementsType;
  onOrderTemplateChange: (name: string, value: SupplementsType) => void;
  editable: boolean;
  setPeriodStartDateIsRequired?: Dispatch<SetStateAction<boolean | null>>;
  handleVariationSpecificSettings?: (data: VariationSpecificSettings) => void;
  date?: Date;
};

const OrderSupplements = ({
  tesId,
  tesVariation,
  supplements,
  onOrderTemplateChange,
  editable,
  setPeriodStartDateIsRequired,
  handleVariationSpecificSettings,
  date,
}: Props) => {
  const { t } = useTranslation();

  const isLoading = useIsLoading(["supplements"]);
  const supplementsData: SupplementsData = Object.fromEntries(
    Object.entries(supplements || {}).map(([key, value]) => {
      return [key, { mode: value as string, definition: undefined }];
    }),
  );

  const onAddSupplement = (key: string, mode: string) => {
    const updatedSupplements = {
      ...supplements,
      [key]: mode,
    };

    onOrderTemplateChange("supplements", updatedSupplements);
    return true; // TODO: Return true if successful
  };

  const onEditSupplement = (key: string, mode: string) => {
    // TODO: supplement type must be ON_OFF to allow editing?
    const updatedSupplements = {
      ...supplements,
      [key]: mode,
    };
    onOrderTemplateChange("supplements", updatedSupplements);
    return true; // TODO: Return true if successful
  };

  const onDeleteSupplement = (key: string) => {
    const updatedSupplements = { ...supplements };
    delete updatedSupplements[key];
    onOrderTemplateChange("supplements", updatedSupplements);
    return true; // TODO: Return true if successful
  };

  const epoch = useMemo(() => getTime(date || new Date()), [date]);

  return (
    <>
      <Grid item xs={3} />
      <Grid item xs={9}>
        <Supplements
          areTesVariationsValid={true}
          tesId={tesId}
          tesSelections={tesVariation}
          date={epoch}
          supplements={supplementsData || {}}
          isLoading={isLoading}
          onEdit={onEditSupplement}
          onAdd={onAddSupplement}
          onDelete={onDeleteSupplement}
          setPeriodStartDateIsRequired={setPeriodStartDateIsRequired}
          handleVariationSpecificSettings={handleVariationSpecificSettings}
          modalTitle={t("order:supplementsModalTitle").toUpperCase()}
          modalSupplementSelectLabel={t("order:supplementSelectLabel")}
          modalSupplementOptionalityLabel={t(
            "order:supplementOptionalityLabel",
          )}
          tableWidth="446px"
          editable={editable}
        />
      </Grid>
    </>
  );
};

export default OrderSupplements;
